import { TSelfEnrollmentProgress } from '@api/io/session.io';
import { faCircleDashed } from '@fortawesome/pro-solid-svg-icons/faCircleDashed';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { useIntl } from 'react-intl';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { TagType } from '@fe-learner-common';

type Tag = {
  icon: IconDefinition;
  type: TagType;
  text: string;
};

const progressTagMap: Record<TSelfEnrollmentProgress, Tag | null> = {
  incomplete: {
    icon: faCircleDashed,
    type: 'prominence',
    text: 'learner.common.course.status.incomplete',
  },
  completed: {
    icon: faCheckCircle,
    type: 'positive',
    text: 'learner.common.course.status.completed',
  },
  notAttempted: {
    icon: faCircleDashed,
    type: 'attention',
    text: 'learner.common.course.status.notAttempted',
  },
  unknown: null,
};

export const useProgressTag = (progress?: TSelfEnrollmentProgress | null) => {
  const intl = useIntl();
  const progressTag = progressTagMap[progress || 'notAttempted'];

  if (!progressTag) {
    return null;
  }

  return {
    icon: progressTag.icon,
    type: progressTag.type,
    text: intl.formatMessage({
      id: progressTag.text,
    }),
  };
};
